<template>
  <NewTooltip v-if="props.showTooltip" :content="$t('unpaired-from-page-tag')">
    <Tag :icon="'unpairLinkIcon'" :show-close="false" :tag-colors="TagColors.Black" :size="TagSizes.Small" />
  </NewTooltip>
  <Tag
    v-else :icon="'unpairLinkIcon'" :show-close="false" :tag-colors="TagColors.Black"
    :size="TagSizes.Small"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import Tag from '../../common/tag/Tag.vue'
import { TagSizes, TagColors } from '../../common/tag/utils'
import NewTooltip from '@/components/common/tooltips/NewTooltip.vue'

const props = defineProps({
  showTooltip: { type: Boolean, default: true }
})

const { t: $t } = useI18n()
</script>

<style scoped lang="scss">
:deep(.icon) {
  filter: brightness(0) invert(1);
}
</style>
